"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookingPage = void 0;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const Alert_1 = __importDefault(require("react-bootstrap/Alert"));
const Col_1 = __importDefault(require("react-bootstrap/Col"));
const Container_1 = __importDefault(require("react-bootstrap/Container"));
const Row_1 = __importDefault(require("react-bootstrap/Row"));
const react_error_boundary_1 = require("react-error-boundary");
const react_helmet_1 = require("react-helmet");
const react_router_dom_1 = require("react-router-dom");
const configContext_1 = require("../../context/configContext");
const environment_1 = require("../../environment");
const BookingStatus_1 = require("../../models/BookingStatus");
const CustomerBooking_1 = require("../../models/CustomerBooking");
const InvoiceStatus_1 = require("../../models/InvoiceStatus");
const dateUtils = __importStar(require("../../utils/dateUtils"));
const IconCalendar_1 = require("../icons/IconCalendar");
const IconFeedback_1 = require("../icons/IconFeedback");
const IconPictureAsPdf_1 = require("../icons/IconPictureAsPdf");
const IconQrCode2_1 = require("../icons/IconQrCode2");
const IconSpeakerNotes_1 = require("../icons/IconSpeakerNotes");
const IconTime_1 = require("../icons/IconTime");
const NumericFormatTwoDecimals_1 = require("../numeric-format/NumericFormatTwoDecimals");
const QrBill_1 = require("../qr-bill/QrBill");
const BookingInfo_1 = require("./BookingInfo");
require("./BookingPage.scss");
const QrBillErrorFallback = (props) => {
    return (react_1.default.createElement(Alert_1.default, { variant: "danger" },
        react_1.default.createElement("p", null, "QR-Code konnte nicht erstellt werden:"),
        react_1.default.createElement("pre", null, props.error.message)));
};
const BookingPage = (props) => {
    const { bookingId } = (0, react_router_dom_1.useParams)();
    if (!bookingId) {
        throw new Error("No bookingId provided in url parameters.");
    }
    const [booking, setBooking] = (0, react_1.useState)();
    const [config, setConfig] = (0, react_1.useState)();
    const [modal, setModal] = (0, react_1.useState)();
    function showModal(newModal) {
        setModal(newModal);
    }
    function hideModal() {
        setModal(undefined);
    }
    const [alert, setAlert] = (0, react_1.useState)();
    function showAlert(newAlert) {
        setAlert(newAlert);
    }
    // Load booking from Firestore.
    (0, react_1.useEffect)(() => {
        const abortController = new AbortController();
        async function fetchBooking() {
            try {
                const response = await fetch(`${(0, environment_1.getEnv)().baseUrl}/api/bookings/${bookingId}`, { signal: abortController.signal });
                if (response.status !== 200) {
                    showAlert(react_1.default.createElement(Alert_1.default, { className: "mt-3", variant: "danger" },
                        "Buchung nicht gefunden: id=",
                        bookingId));
                }
                else {
                    const responseJson = await response.json();
                    const config = await (0, configContext_1.loadConfig)(responseJson.tenantId);
                    setConfig(config);
                    setBooking(CustomerBooking_1.CustomerBooking.fromJSON(bookingId, responseJson, config));
                }
            }
            catch (error) {
                if (!abortController.signal.aborted) {
                    throw error;
                }
            }
        }
        fetchBooking();
        return () => abortController.abort();
    }, [bookingId]);
    if (alert) {
        return react_1.default.createElement(Container_1.default, null, alert);
    }
    if (!booking || !config) {
        return react_1.default.createElement("p", { className: "mt-5 text-center" }, "Wird geladen...");
    }
    const addonRows = [];
    booking.addonItems.forEach((addon) => {
        addonRows.push(react_1.default.createElement("tr", { className: `item${addon.discount ? " has-discount" : ""}`, key: addon.title },
            react_1.default.createElement("td", null, addon.title),
            react_1.default.createElement("td", null, `${addon.quantity} ${addon.unit}`),
            react_1.default.createElement("td", null,
                react_1.default.createElement(NumericFormatTwoDecimals_1.NumericFormatTwoDecimals, { value: addon.price }))));
        if (addon.discount) {
            addonRows.push(react_1.default.createElement("tr", { className: "discount", key: `${addon.title}-discount` },
                react_1.default.createElement("td", null,
                    "\u2517\u2501 ",
                    addon.discount.title),
                react_1.default.createElement("td", null, addon.discount.isPercent() ? `(${addon.discount.percent}%)` : ""),
                react_1.default.createElement("td", null,
                    "-",
                    react_1.default.createElement(NumericFormatTwoDecimals_1.NumericFormatTwoDecimals, { value: addon.discount.calc(addon.price) }))));
        }
    });
    const totals = booking.calcTotals();
    const paymentInfo = getPaymentInfo(config, booking);
    let showQrBill = 
    // Only show QR bill if it is an invoice.
    InvoiceStatus_1.InvoiceStatus.allInvoiceVisibleStatus.includes(booking.invoiceStatus) &&
        // No QR-Bill for legacy addresses.
        !booking.contact.isLegacyAddress();
    const qrBill = getQrBill(config, booking, totals.outstandingBalance);
    const qrBillModal = getQrBillModal(qrBill, booking, hideModal);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_1.Helmet, null,
            react_1.default.createElement("title", null,
                booking.reference,
                " ",
                config.name)),
        react_1.default.createElement("div", { className: "booking-page d-flex flex-column align-items-center" },
            react_1.default.createElement("div", { className: "page-header no-print" },
                showQrBill && (react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-dark", onClick: () => showModal(qrBillModal) },
                    react_1.default.createElement(IconQrCode2_1.IconQrCode2, null),
                    " QR-Rechnung")),
                react_1.default.createElement("a", { className: "btn btn-outline-dark ml-2", href: `${(0, environment_1.getEnv)().baseUrl}/bookings/${bookingId}/pdf`, target: "_blank" },
                    react_1.default.createElement(IconPictureAsPdf_1.IconPictureAsPdf, { className: "mr-1" }),
                    "Als PDF herunterladen")),
            react_1.default.createElement("div", { className: "booking-box" },
                react_1.default.createElement("div", { className: `no-print status status-${booking.getRelevantStatus().name}-bg` }, booking.getRelevantStatus().nameDe),
                react_1.default.createElement("div", { className: "address-block" },
                    react_1.default.createElement("div", { className: "owner" },
                        react_1.default.createElement("div", { className: "owner-logo" },
                            react_1.default.createElement("a", { href: config.website, target: "_blank" },
                                react_1.default.createElement("img", { src: config.getImageUrl(config.logo) }))),
                        react_1.default.createElement("div", { className: "owner-address" },
                            react_1.default.createElement("div", { className: "text-pre-line" },
                                config.fullName + "\n",
                                config.address.trim() + "\n",
                                config.zip,
                                " ",
                                config.city),
                            react_1.default.createElement("div", null,
                                react_1.default.createElement("a", { href: `mailto:${config.email}`, target: "_blank" }, config.email)))),
                    react_1.default.createElement("div", { className: "contact text-pre-line" }, booking.contact.getAddressBlock())),
                react_1.default.createElement(BookingInfo_1.BookingInfo, { config: config, booking: booking }),
                react_1.default.createElement("table", { className: "item-table" },
                    react_1.default.createElement("tbody", null,
                        react_1.default.createElement("tr", { className: "heading" },
                            react_1.default.createElement("td", null, "Artikel"),
                            react_1.default.createElement("td", null, "Menge"),
                            react_1.default.createElement("td", null, "Preis in CHF")),
                        react_1.default.createElement("tr", { className: `item${booking.resourceItem.discount ? " has-discount" : ""}` },
                            react_1.default.createElement("td", null,
                                react_1.default.createElement("div", { className: "strong" },
                                    booking.resourceItem.type,
                                    " \u00AB",
                                    booking.resourceItem.title,
                                    "\u00BB"),
                                react_1.default.createElement("div", { className: "d-flex" },
                                    react_1.default.createElement("div", null,
                                        react_1.default.createElement("div", { className: "strong" },
                                            react_1.default.createElement(IconCalendar_1.IconCalendar, null),
                                            " ",
                                            react_1.default.createElement("span", { className: booking.status.isBusy() ? "" : "strike" }, dateUtils.formatDate(booking.start, {
                                                timeZone: config.timeZone,
                                            }))),
                                        react_1.default.createElement("div", { className: "strong" },
                                            react_1.default.createElement(IconTime_1.IconTime, null),
                                            " ",
                                            react_1.default.createElement("span", { className: booking.status.isBusy() ? "" : "strike" },
                                                dateUtils.formatTime(booking.start, {
                                                    timeZone: config.timeZone,
                                                }),
                                                " ",
                                                "-",
                                                " ",
                                                dateUtils.formatTime(booking.end, {
                                                    timeZone: config.timeZone,
                                                })))),
                                    (booking.status === BookingStatus_1.BookingStatus.provisional ||
                                        booking.status === BookingStatus_1.BookingStatus.cancelled) && (react_1.default.createElement("div", { className: `align-self-center strong ml-3 status-${booking.status.name}`, title: `Buchung ${booking.status.nameDe}` },
                                        "\u2192 Buchung ist ",
                                        booking.status.nameDe,
                                        "!")))),
                            react_1.default.createElement("td", null, `${booking.resourceItem.quantity} ${booking.resourceItem.unit}`),
                            react_1.default.createElement("td", null,
                                react_1.default.createElement(NumericFormatTwoDecimals_1.NumericFormatTwoDecimals, { value: booking.resourceItem.price }))),
                        booking.resourceItem.discount && (react_1.default.createElement("tr", { className: "discount" },
                            react_1.default.createElement("td", null,
                                "\u2517\u2501 ",
                                booking.resourceItem.discount.title),
                            react_1.default.createElement("td", null, booking.resourceItem.discount.percent
                                ? `(${booking.resourceItem.discount.percent}%)`
                                : ""),
                            react_1.default.createElement("td", null,
                                "-",
                                react_1.default.createElement(NumericFormatTwoDecimals_1.NumericFormatTwoDecimals, { value: booking.resourceItem.discount.calc(booking.resourceItem.price) })))),
                        addonRows,
                        react_1.default.createElement("tr", { className: "total" },
                            react_1.default.createElement("td", null),
                            react_1.default.createElement("td", { className: "font-weight-bold" }, "Total"),
                            react_1.default.createElement("td", { className: "font-weight-bold" },
                                react_1.default.createElement(NumericFormatTwoDecimals_1.NumericFormatTwoDecimals, { value: totals.totalPrice }))),
                        booking.discount &&
                            discountRow(booking.discount, totals.totalPrice),
                        booking.hasVoidedInvoice() && (react_1.default.createElement("tr", { className: "invoice-void" },
                            react_1.default.createElement("td", null),
                            react_1.default.createElement("td", null, "Rechnung storniert"),
                            react_1.default.createElement("td", null,
                                react_1.default.createElement(NumericFormatTwoDecimals_1.NumericFormatTwoDecimals, { value: -totals.voidedAmount })))),
                        paymentRows(config, booking.payments),
                        (booking.discount ||
                            booking.hasVoidedInvoice() ||
                            booking.payments.length > 0) && (react_1.default.createElement("tr", { className: "balance" },
                            react_1.default.createElement("td", null),
                            react_1.default.createElement("td", { className: "font-weight-bold" }, "Offener Betrag"),
                            react_1.default.createElement("td", { className: "font-weight-bold" },
                                react_1.default.createElement(NumericFormatTwoDecimals_1.NumericFormatTwoDecimals, { value: totals.outstandingBalance })))),
                        buildTaxRows(totals.taxes, config.taxNumber))),
                react_1.default.createElement("div", { className: "booking-box-footer" },
                    react_1.default.createElement("h5", null, "Zahlungsinfos"),
                    paymentInfo,
                    showQrBill && (react_1.default.createElement(react_bootstrap_1.Button, { className: "no-print", variant: "outline-dark", onClick: () => showModal(qrBillModal) },
                        react_1.default.createElement(IconQrCode2_1.IconQrCode2, null),
                        " QR-Rechnung anzeigen")),
                    react_1.default.createElement("div", { className: "text-right small" },
                        "Buchung erstellt:",
                        " ",
                        dateUtils.formatDate(booking.created, {
                            timeZone: config.timeZone,
                        })))),
            react_1.default.createElement("div", { className: "comments-box no-pdf-print" },
                react_1.default.createElement(Row_1.default, null,
                    react_1.default.createElement(Col_1.default, { sm: 6 }, booking.commentsByCustomer && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", { className: "d-flex comments-title" },
                            react_1.default.createElement(IconSpeakerNotes_1.IconSpeakerNotes, { className: "comments-icon", size: "2em" }),
                            react_1.default.createElement("div", null,
                                react_1.default.createElement("h6", { className: "mb-0" }, "Bemerkungen"),
                                react_1.default.createElement("div", { className: "small" }, booking.getContactOrgOrName()))),
                        react_1.default.createElement("div", { className: "text-pre-line" }, booking.commentsByCustomer)))),
                    react_1.default.createElement(Col_1.default, { sm: 6 }, booking.commentsByStaff && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", { className: "d-flex comments-title" },
                            react_1.default.createElement(IconFeedback_1.IconFeedback, { className: "comments-icon", size: "2em" }),
                            react_1.default.createElement("div", null,
                                react_1.default.createElement("h6", { className: "mb-0" }, "Bemerkungen"),
                                react_1.default.createElement("div", { className: "small" }, config.name))),
                        react_1.default.createElement("div", { className: "text-pre-line" }, booking.commentsByStaff)))))),
            react_1.default.createElement("div", { className: "page-footer text-center no-print" },
                react_1.default.createElement("hr", null),
                "Made with \u2728 by",
                " ",
                react_1.default.createElement("a", { href: "https://www.benjibooks.com", target: "_blank" }, "Benjibooks")),
            modal),
        showQrBill && (react_1.default.createElement("div", { className: "booking-page-qr-bill-container print" }, qrBill))));
};
exports.BookingPage = BookingPage;
function getPaymentInfo(config, booking) {
    switch (booking.getRelevantStatus()) {
        case BookingStatus_1.BookingStatus.provisional:
            return (react_1.default.createElement("p", null, "Die Buchung ist noch provisorisch. Sie wird vom Team \u00FCberpr\u00FCft und best\u00E4tigt."));
        case BookingStatus_1.BookingStatus.confirmed:
            return (react_1.default.createElement("p", null, "Nach dem gebuchten Tag wirst du von uns per E-Mail eine Rechnung erhalten."));
        case BookingStatus_1.BookingStatus.cancelled:
            return (react_1.default.createElement("p", null, "Die Buchung wurde annulliert. Du wirst von uns benachrichtigt, falls Annullationsgeb\u00FChren anfallen."));
        case InvoiceStatus_1.InvoiceStatus.open:
        case InvoiceStatus_1.InvoiceStatus.partial:
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("p", null, "Die Rechnung ist zahlbar innert 10 Tagen."),
                react_1.default.createElement("p", null,
                    "Bank: ",
                    config.bank.name,
                    react_1.default.createElement("br", null),
                    "Kontoinhaber: ",
                    config.bank.accountHolder,
                    react_1.default.createElement("br", null),
                    "BIC: ",
                    config.bank.accountBic,
                    react_1.default.createElement("br", null),
                    "IBAN: ",
                    config.bank.accountIban,
                    react_1.default.createElement("br", null),
                    "Referenznummer: ",
                    react_1.default.createElement("strong", null, booking.reference),
                    " (bitte vermerken!)")));
        case InvoiceStatus_1.InvoiceStatus.paid:
            return react_1.default.createElement("p", null, "Die Rechnung wurde vollst\u00E4ndig bezahlt. Vielen Dank!");
        case InvoiceStatus_1.InvoiceStatus.zero:
            return react_1.default.createElement("p", null, "Es gibt nichts zu bezahlen.");
        case InvoiceStatus_1.InvoiceStatus.void:
            return react_1.default.createElement("p", null, "Die Rechnung wurde storniert. Es gibt nichts zu bezahlen.");
        default:
            return react_1.default.createElement("p", null, "---");
    }
}
function paymentRows(config, payments) {
    return payments.map((payment, index) => (react_1.default.createElement("tr", { key: index, className: "payment" },
        react_1.default.createElement("td", null),
        react_1.default.createElement("td", { className: "text-nowrap" },
            payment.getPaymentType(),
            " ",
            dateUtils.formatDate(payment.date, { timeZone: config.timeZone })),
        react_1.default.createElement("td", null,
            react_1.default.createElement(NumericFormatTwoDecimals_1.NumericFormatTwoDecimals, { value: -payment.amount })))));
}
function discountRow(discount, totalPrice) {
    return (react_1.default.createElement("tr", { className: "discount" },
        react_1.default.createElement("td", null),
        react_1.default.createElement("td", null,
            discount.title,
            " ",
            discount.isPercent() ? `(${discount.percent}%)` : ""),
        react_1.default.createElement("td", null,
            react_1.default.createElement(NumericFormatTwoDecimals_1.NumericFormatTwoDecimals, { value: -discount.calc(totalPrice) }))));
}
function buildTaxRows(taxes, taxNumber) {
    const taxRows = taxes.map((tax, index) => (react_1.default.createElement("tr", { key: tax.taxRate, className: "tax" + (index === 0 ? " first" : "") },
        react_1.default.createElement("td", null),
        react_1.default.createElement("td", { colSpan: 2 },
            "inkl. ",
            tax.taxRate,
            "% MWST, CHF",
            " ",
            react_1.default.createElement(NumericFormatTwoDecimals_1.NumericFormatTwoDecimals, { value: tax.taxAmount })))));
    // Add a row for the tax number.
    taxRows.push(react_1.default.createElement("tr", { key: "tax-number", className: "tax" },
        react_1.default.createElement("td", null),
        react_1.default.createElement("td", { colSpan: 2 }, taxNumber ? `(${taxNumber} MWST)` : "(nicht MWST-pflichtig)")));
    return taxRows;
}
function getQrBill(config, booking, outstandingBalance) {
    return (react_1.default.createElement(react_error_boundary_1.ErrorBoundary, { FallbackComponent: QrBillErrorFallback },
        react_1.default.createElement(QrBill_1.QrBill, { data: {
                currency: "CHF",
                amount: outstandingBalance < 1000000000 ? outstandingBalance : undefined,
                message: booking.reference,
                creditor: {
                    account: config.bank.accountIban,
                    name: config.bank.accountHolder.slice(0, 70),
                    address: config.address.split("\n")[0].slice(0, 70),
                    zip: config.zip.slice(0, 16),
                    city: config.city.slice(0, 35),
                    country: config.country,
                },
                debtor: {
                    name: booking.getContactOrgOrName().slice(0, 70),
                    address: booking.contact.address.split("\n")[0].slice(0, 70),
                    zip: booking.contact.zip.slice(0, 16),
                    city: booking.contact.city.slice(0, 35),
                    country: booking.contact.country,
                },
            }, language: "DE" })));
}
function getQrBillModal(qrBill, booking, hideModal) {
    return (react_1.default.createElement(react_bootstrap_1.Modal, { className: "booking-page-qr-bill-modal", show: true, onHide: hideModal, animation: false, centered: true },
        react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
            react_1.default.createElement(react_bootstrap_1.Modal.Title, null,
                "Buchung ",
                booking.reference)),
        react_1.default.createElement(react_bootstrap_1.Modal.Body, null, qrBill)));
}
